import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateField } from '../actions';

const BarTips = ({ shift, sid }) => {
  const dispatch = useDispatch();
  const [sushiTip, setSushiTip] = useState(shift.SushiTip);
  const [expoTip, setExpoTip] = useState(shift.ExpoTip);
  const [hostTip, setHostTip] = useState(shift.HostTip);
  const [busserTip, setBusserTip] = useState(shift.BusserTip);
  const [finalTipOut, setFinalTipOut] = useState(shift.FinalTipOut);
  const [notes, setNotes] = useState(shift.Notes);
  useEffect(() => {
    setSushiTip(shift.SushiTip);
    setExpoTip(shift.ExpoTip);
    setHostTip(shift.HostTip);
    setBusserTip(shift.BusserTip);
    setFinalTipOut(shift.FinalTipOut);
    setNotes(shift.Notes);
  }, [shift]);
  return !shift.IsLunch ? (
    <div>
      <span>
        <label>Net Sales: </label>{' '}
        {Number((shift.NetSales * shift.BarRatio).toFixed(2))}&nbsp;&nbsp;
      </span>
      <span>
        <label>CC Tip (After withholding): </label>{' '}
        {Number((shift.CCTip * shift.BarRatio).toFixed(2))}&nbsp;&nbsp;
      </span>
      {/* <span><label>CC Fee: </label> {Number((shift.CCTipFee * shift.BarRatio).toFixed(2))}&nbsp;&nbsp;</span> */}
      <br />
      {/* <span><label>After ratio is applied: &nbsp;&nbsp;</label></span> */}
      <span>
        <label>Sushi Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={sushiTip}
          onChange={(e) => setSushiTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, sushiTip, 'SUSHITIP'));
          }}
        />
      </span>
      <span>
        <label>Expo Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={expoTip}
          onChange={(e) => setExpoTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, expoTip, 'EXPOTIP'));
          }}
        />
      </span>
      <span>
        <label>Host Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={hostTip}
          onChange={(e) => setHostTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, hostTip, 'HOSTTIP'));
          }}
        />
      </span>
      <span>
        <label>Busser Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={busserTip}
          onChange={(e) => setBusserTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, busserTip, 'BUSSERTIP'));
          }}
        />
      </span>
      <span>
        <label>Final Tip Out</label>
        <input
          type="text"
          name="hours"
          style={{ width: '100px' }}
          value={finalTipOut}
          onChange={(e) => setFinalTipOut(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, finalTipOut, 'FINALTIPOUT'));
          }}
        />
      </span>
      <span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <label>Notes:&nbsp;&nbsp;</label>
        <input
          type="text"
          name="notes"
          style={{ width: '200px' }}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, notes, 'NOTES'));
          }}
        />
      </span>
    </div>
  ) : (
    <div>
      <span>
        <label>Sushi Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={sushiTip}
          onChange={(e) => setSushiTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, sushiTip, 'SUSHITIP'));
          }}
        />
      </span>
      <span>
        <label>Host Tip</label>
        <input
          type="text"
          name="hours"
          style={{ width: '50px' }}
          value={hostTip}
          onChange={(e) => setHostTip(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, hostTip, 'HOSTTIP'));
          }}
        />
      </span>
      <span>
        <label>Final Tip Out</label>
        <input
          type="text"
          name="hours"
          style={{ width: '100px' }}
          value={finalTipOut}
          onChange={(e) => setFinalTipOut(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, finalTipOut, 'FINALTIPOUT'));
          }}
        />
      </span>
      <span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <label>Notes:&nbsp;&nbsp;</label>
        <input
          type="text"
          name="notes"
          style={{ width: '200px' }}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          onBlur={() => {
            dispatch(updateField(sid, notes, 'NOTES'));
          }}
        />
      </span>
    </div>
  );
};

export default BarTips;
